/**
 * Formatea duración (en horas decimales) a "2h 30min" / "2h" / "30min"
 * Ejemplos:
 *   2.5 -> "2h 30min"
 *   2.0 -> "2h"
 *   0.5 -> "30min"
 *   0.25 -> "15min"
 */
export const formatDuration = (durationHours) => {
  const d = Number(durationHours) || 0;
  const totalMin = Math.round(d * 60);
  const h = Math.floor(totalMin / 60);
  const m = totalMin % 60;
  if (h === 0 && m === 0) return "0h";
  if (h === 0) return `${m}min`;
  if (m === 0) return `${h}h`;
  return `${h}h ${m}min`;
};
